import React, { useEffect, useState } from 'react';
import { getAvailability } from '../api';

function fmt(iso, timezone) {
  const d = new Date(iso);
  try {
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZone: timezone });
  } catch {
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }
}

export default function StepTime({ slug, serviceId, staffId, date, timezone, onSelect, selected }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setGroups([]);
    getAvailability(slug, { serviceId, staffId, date })
      .then(data => {
        const raw = Array.isArray(data) ? data : [];
        // availabilityService returns staffColor; normalise to color
        setGroups(raw.map(g => ({ ...g, color: g.staffColor || g.color || 'var(--primary)' })));
      })
      .catch(err => {
        const msg = err.response?.data?.error?.message || err.message || 'Could not load times.';
        setError(msg);
      })
      .finally(() => setLoading(false));
  }, [slug, serviceId, staffId, date]);

  if (loading) return (
    <div className="w-loading">
      <div className="w-spinner" />
      <span>Loading times…</span>
    </div>
  );

  if (error) return (
    <div className="w-error">
      {error}
      <div style={{ marginTop: 8, fontSize: 12, opacity: 0.8 }}>
        Please go back and try a different date or contact us directly.
      </div>
    </div>
  );

  const hasSlots = groups.some(g => g.slots && g.slots.length > 0);
  if (!hasSlots) return (
    <div className="w-empty">
      No available times on this date.<br />
      <span style={{ fontSize: 12 }}>Try selecting a different date.</span>
    </div>
  );

  return (
    <>
      <div className="w-title">Choose a time</div>
      {groups.filter(g => g.slots && g.slots.length > 0).map(g => (
        <div key={g.staffId} className="w-staff-group" style={{ '--dot-color': g.color }}>
          <div className="w-staff-name">{g.staffName}</div>
          <div className="w-slots">
            {g.slots.map(slot => (
              <button
                key={slot}
                className={`w-slot ${selected && selected.slot === slot && selected.staffId === g.staffId ? 'selected' : ''}`}
                onClick={() => onSelect({ slot, staffId: g.staffId, staffName: g.staffName })}
              >
                {fmt(slot, timezone)}
              </button>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
